
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import MyExpenseList from './MyExpenseList';
import Loader from '../../components/modal/Loader';
import FileAttachedModal from '../../components/modal/FileAttachedModal';
import Button from '../../components/button/Button';
import ModifyRoutes from './ModifyRoutes';
import PopupModal from '../../components/modal/PopupModal';
import {
  fetchDayWiseExpense,
  fetchAttachmentDayWise,
  deletedAttachmentDayWise,
  fetchDayWiseTotalExpense,
  getExpenseDayWiseAll,
  expenseUpdateDateWiseSubmit,
  expenseDetailsRefresh
  // getAttachmentDaywise
} from '../../redux/slice/myExpenseDayWiseSlice';
import { expenseAttachment } from '../../redux/slice/expenseApproval';
import { useLocation,useParams } from 'react-router-dom';
import PreviewModal from '../uploadBills/PreviewModal';
// images
import attachmentIcon from '/assets/images/attachmentIcon.png';
import removeIcon from '/assets/images/removeIcon.png';
import leftArrowIcon from '/assets/images/leftArrowIcon.png';
import Successpop from '../stpfc/Successpop';
import defaultPDF from '../../../public/assets/images/defaultPDF.png';

import { userInfo } from '../../utils/Constant';
import { Tooltip } from 'react-tooltip';
const { employeeId } = userInfo;
const MyExpenseDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    isLoading,
    apiError,
    errorMessage,
    dayWiseExpense,
    attachmentDayWise,
    dayWiseTotalExpense,
    expenseRefresh
  } = useSelector(getExpenseDayWiseAll);

  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showSuccessModal, setSuccessModal] = useState(false);
  const [showPopupmsg, setShowPopupmsg] = useState(false);
  const [message, setMessage] = useState('');

  const toggleDrawer = () => setDrawerOpen(!isDrawerOpen);

  const location = useLocation();
  const selectedExpenseData = JSON.parse(localStorage.getItem('SelectedExpenseData'));
  const expenseId = selectedExpenseData?.expenseId;
  const isComingFromExpenseDetails =selectedExpenseData?.from === 'expense-details' || location?.state?.fromHomePage;
  const item = dayWiseExpense?.find(i => i.expenseModifyEnable === 1);

  const handleBackClick = () => {
    if (isComingFromExpenseDetails && !(location?.state?.fromHomePage)) {
      navigate(`/expense-details/${expenseId}`);
    } else {
      navigate('/my-expense');
    }
    localStorage.removeItem('SelectedExpenseData');
  };

  useEffect(() => {
    const selectedExpenseData = localStorage.getItem('SelectedExpenseData');
    console.log('Fetched from localStorage:', selectedExpenseData);
    if (selectedExpenseData) {
      const { employeeId, expenseDetailId, expenseId, activityDate } = JSON.parse(selectedExpenseData);
      // Dispatch Expense Attachment slice from Expense Approval Details Page
      dispatch(expenseAttachment(employeeId, expenseDetailId, expenseId, activityDate));

      dispatch(fetchDayWiseExpense(activityDate));
      dispatch(fetchDayWiseTotalExpense());

    }
  }, [dispatch, isDrawerOpen]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);

  const handleDownload = (item) => {
    const base64Data = item.imageBase64;
    const link = document.createElement('a');
    link.href = `data:image/png;base64,${base64Data}`;
    link.download = `${item.expenseType || 'attachment'}.png`;
    link.click();
  };

  useEffect(() => {
    const fetchAttachments = async () => {
      const response = await dispatch(fetchAttachmentDayWise());
      console.log('Attachment response:', response);
    };

    fetchAttachments();
  }, [dispatch]);

  const handleNavigate = () => {
    navigate('/my-expense');
    localStorage.removeItem('SelectedExpenseData');
  };

  const handleDeleteAttachment = async (item) => {
    await dispatch(deletedAttachmentDayWise(item));
    dispatch(fetchAttachmentDayWise());
    dispatch(fetchDayWiseTotalExpense());
  };

  const handleRefresh = async () => {
    console.log("Refresh button clicked");

    const result = await dispatch(expenseDetailsRefresh());

    if (expenseDetailsRefresh.fulfilled.match(result)) {
      const message = result.payload;
      console.log("message",message)
      setMessage(message);
      setShowPopupmsg(true);

      setTimeout(() => {
        setShowPopupmsg(false);
        setMessage('');
      }, 3000);
    }
  };


  // const handlerNavigate = (navigateTo) => {
  //   navigate(navigateTo);
  // };

  const handlerSaveUpdate = () => {
    let { total } = dayWiseTotalExpense;
    const selectedExpenseData = localStorage.getItem('SelectedExpenseData');
    const { activityDate, expenseId } = JSON.parse(selectedExpenseData);
    const data = {
      employeeId,
      total,
      activityDate,
      expenseId,
    };
    dispatch(expenseUpdateDateWiseSubmit(data));
    setSuccessModal(true);
    setTimeout(() => {
      navigate('/my-expense');
      localStorage.removeItem('SelectedExpenseData');
    }, 1000);
  };

  const closeModal = () => {
    setSuccessModal(false);
  };

  if (isLoading) {
    return <Loader />;
  }

  if (apiError) {
    return <div className="text-red-500">{errorMessage}</div>;
  }

  const dividerClass = 'divider-y h-[0.5px] w-full bg-line-color';

  return (
    <div className="w-full h-screen flex lg:pt-14 lg:pl-2 lg:pr-8">
      <div className="w-full bg-white relative flex flex-col">
        <header className="w-full lg:pl-2 smAndMd:px-2 py-2 flex items-center  smAndMd:pt-6  smAndMd:pb-6">
          <div className="flex-1 flex items-center">
            <button onClick={handleBackClick} className="lg:hidden mr-4">
              <img
                src={leftArrowIcon}
                alt="leftIcon"
                height={'10px'}
                width={'10px'}
              />
            </button>
            <p className="text-baselg font-semibold  text-primary">
              Expense Details
            </p>
          </div>
        {item && !isComingFromExpenseDetails && (
        <button
          onClick={toggleDrawer}
          className="font-semibold text-baseSm lg:text-baseMd text-primary smAndMd:pt-6"
        >
          Modify
        </button>
      )}

          {!isComingFromExpenseDetails && (
          <button
           onClick={handleRefresh}
            className="font-semibold text-baseSm lg:text-baseMd pl-5 text-primary smAndMd:pt-6 smAndMd:pl-5"
          >
            Refresh
          </button>
          )}
          <ModifyRoutes isOpen={isDrawerOpen} onClose={toggleDrawer} />
        </header>
        <div className='w-[99%] ml-2 border-b border-line-color'></div>




        <div className="flex flex-col lg:flex-row">
          <div className="lg:w-8/12  lg:border-line-color lg:pt-2  lg:max-h-[calc(500px-80px)] lg:overflow-y-auto scrollbar-hide">
            {dayWiseExpense &&
              dayWiseExpense.length > 0 &&
              dayWiseExpense.map((item, index) => (
                <div key={index}>
                  <div className="flex justify-between items-center">
                    <MyExpenseList
                      id={index}
                      item={item}
                      className="w-full lg:w-7/12"
                    />
                  </div>
                  <div className="divider-y h-[2px] lg:h-0 bg-line-color"></div>
                </div>
              ))}
          </div>

          <div className="lg:w-4/12  lg:mt-6 border-l-[0.5px] border-line-color  lg:h-[65vh]">
            <div
              className="flex justify-between pl-4 pt-1"
              style={{ backgroundColor: '#F7F0FF', height: '54px' }}
            >
              <div className="pt-1">
                <p className="font-bold text-base lg:text-baseMd">
                  Total Expense Details
                </p>
                <p className="text-baseXSm">Attach other allowance here</p>
              </div>
              {!isComingFromExpenseDetails && (
              <button
                onClick={() => setShowModal(!showModal)}
                className="px-4 py-2 lg:py-0 text-white relative"
                style={{ borderColor: '#A04D95' }}
                data-tooltip-id='attach'
                data-tooltip-content='Attach receipts /bills'
                data-tooltip-place='bottom'
              >
                <FileAttachedModal
                  onClose={closeModal}
                  showModal={showModal}
                  onClick={() => setShowModal(!showModal)}
                />
                <img
                  src={attachmentIcon}
                  alt="attachmentIcon"
                  height={'20px'}
                  width={'20px'}
                />
                <Tooltip id='attach' className='!text-xs'/>
              </button>
              )}
            </div>

            <div className="flex justify-between my-3 pl-4 pr-4 lg:w-full">
              <p className="text-baseSm text-[#7A7A7A]">Total Fare</p>
              <p className="text-baseSm text-[#7A7A7A] font-medium">
                ₹ {dayWiseTotalExpense?.fare || 0}
              </p>
            </div>

             <div className="flex justify-between my-3 pl-4 pr-4 lg:w-full">
              <p className="text-baseSm text-[#7A7A7A]">Total Allowance</p>
              <p className="text-baseSm text-[#7A7A7A] font-medium">
                ₹ {dayWiseTotalExpense?.allowance || 0}
              </p>
            </div>

            {/* Attachments List */}
            {attachmentDayWise &&
              attachmentDayWise.length > 0 &&
              attachmentDayWise.map((item) => (
                <div
                  key={item.expenseAttachmentId}
                  className="flex justify-between my-3 pl-4 pr-4 lg:w-full"
                >
                  <p className="text-baseSm text-[#7A7A7A]">
                    {item.expenseType}
                  </p>
                  <p className="text-baseSm text-[#7A7A7A] font-medium">
                    ₹ {item.fare}
                  </p>
                </div>
              ))}

            {/* Total Section */}
            <div className="divider-y h-[0.5px] w-[92%] bg-line-color ml-4"></div>
            <div className="flex justify-between my-3 pl-4 pr-4 lg:w-full">
              <p className="text-baseMd font-semibold">Total Expense</p>
              <p className="text-baseMd text-primary-black font-medium tracking-[1px]">
                ₹ {dayWiseTotalExpense?.total || 0}
              </p>
            </div>

          <div className="divider-y h-[0.5px] w-full bg-line-color"></div>

          <div className="p-3 pb-32 lg:w-full">
            <p className="text-baseMd font-semibold text-[#514D4C]">
              Attachments
            </p>
            {attachmentDayWise &&
              attachmentDayWise?.length > 0 &&
              attachmentDayWise?.map((item) => (
                <div
                  key={item.expenseAttachmentId}
                  className="flex flex-col justify-between p-1 border border-line-color rounded-lg mt-2 relative"
                >
                  <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <img
                      src={`${(item?.imageBase64)?.endsWith('.pdf') ? defaultPDF : item?.imageBase64}`}
                      alt="attachment"
                      className="w-11 h-11 rounded-lg object-cover"
                    />
                    <div className="ml-2 text-sm">
                      <p>{item.expenseType}</p>
                      <p>{item.fare}</p>
                    </div>
                  </div>
                  {!isComingFromExpenseDetails &&
                  <button onClick={() => handleDeleteAttachment(item)}>
                    <div className="rounded-full   ">
                      <img
                        src={removeIcon}
                        alt="removeIcon"
                        height={'20px'}
                        width={'20px'}
                      />
                    </div>
                  </button>
                  }
                  </div>

                  {isComingFromExpenseDetails && (
                  <div className="flex justify-end space-x-6 -mt-5">
                  <button
                   className="text-baseSm font-medium text-primary "
                    onClick={() => {
                      const type = item.fileType || "image/jpeg";
                      setPreviewFile(`data:${type};base64,${item.imageBase64}`);
                      setIsModalOpen(true);
                    }}>
                    View
                  </button>
                  <button
                    className="text-baseSm font-medium text-primary "
                    onClick={() => handleDownload(item)}
                  >
                  Download
                  </button>
                  </div>
                  )}

                </div>
              ))}
              <PreviewModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                file={previewFile}
                onDownload={handleDownload}
              />

          </div>
        </div>
        </div>
      <div className="fixed bottom-0 w-[76.5%] ml-2 bg-white">
          {/* Divider line */}
          <div className="h-[1px] bg-line-color"></div>

          {/* Buttons */}
          <div className="flex justify-end gap-3 p-3">
            <Button
              label="Back"
              btTextColor="text-primary"
              btBgColor="white"
              btHeight="h-10"
              btWidth="w-36"
              onClick={handleBackClick}
            />
            {!isComingFromExpenseDetails && (
              <Button
                label="Save"
                onClick={handlerSaveUpdate}
                btBgColor="bg-primary"
                btHeight="h-10"
                btWidth="w-36"
                btTextColor="text-white"
              />
            )}
          </div>
        </div>

        {/* Mobile Bottom Buttons */}
        {!isDrawerOpen && (
          <div className="lg:hidden fixed bottom-0 right-0 bg-white border-t-[1px] shadow-top1 h-[7rem] w-full flex justify-around items-center gap-3 p-4">
            <Button
              label="Back"
              btTextColor="text-primary"
              btBgColor="white"
              onClick={handleBackClick}
            />
            {!isComingFromExpenseDetails && (
            <Button
              label="Save"
              onClick={handlerSaveUpdate}
              btBgColor="bg-primary"
              btTextColor="text-white"
            />
            )}
          </div>
        )}


      {/* Refersh Success */}
      {showPopupmsg && (
        <Successpop
        displayText={message}
          onClose={() => setShowPopupmsg(false)}
        />
      )}

        {/* Success Modal */}
        {showSuccessModal && (
          <PopupModal
            time={2000}
            isOpen={showSuccessModal}
            message={'Expense Updated Successfully'}
            type={'success'}
            onClose={closeModal}
          />
        )}
      </div>
    </div>
  );
};

export default MyExpenseDetails;